// extracted by css-extract-rspack-plugin
export default {"cls1":"ReferenceEvaluationPage-cls1_R6x","cls2":"ReferenceEvaluationPage-cls2_EKw ReferenceEvaluationPage-cls1_R6x","spin":"ReferenceEvaluationPage-spin_-gO"};